<script lang="ts">
  import type { SvelteHTMLElements } from 'svelte/elements'

  import NounModalityData from './NounModalityData.svelte'
  import NounModalityRadar from './NounModalityRadar.svelte'
  import NounModalityTimeseries from './NounModalityTimeseries.svelte'

  type Props = {
    color?: string
  } & SvelteHTMLElements['svg']

  let { color = 'currentColor', ...restProps }: Props = $props()
</script>

<svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" {...restProps}>
  <path
    d="M32 25.5v10M23.5 38.5l-8 7M40.5 38.5l8 7"
    fill="none"
    stroke={color}
    stroke-linecap="round"
    stroke-width="2.25"
    opacity="0.55"
  />
  <NounModalityRadar x="20" y="3" width="24" height="30" {color} />
  <NounModalityData x="4" y="36" width="24" height="20" {color} />
  <NounModalityTimeseries x="36" y="35" width="24" height="24" {color} />
</svg>
